module.exports = __webpack_public_path__ + "static/img/businessHome2.6e92cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3D/businessHome2.png
// module id = Rn1D
// module chunks = 1